<div class="upload-container">
    @for (upload of fileUploads; track upload) {
        <div class="upload-item">
            <div class="upload-name">{{ upload.name }}</div>
            <mat-progress-bar mode="determinate" [value]="upload.progress"></mat-progress-bar>
        </div>
    }
</div>
